import { Component, Input, ViewEncapsulation } from '@angular/core';
import { InfoAlertComponent } from '../info-alert/info-alert.component';

@Component({
  selector: 'tm-error-alert',
  templateUrl: './error-alert.component.html',
  styleUrls: ['./error-alert.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ErrorAlertComponent extends InfoAlertComponent {
  /** 表頭標題，預設為"ERROR" */
  @Input() title = 'ERROR';
  /** 確認按鈕標籤 */
  okBtnLabel = '';
  /** 自訂義彈窗的 css 類，預設為"error-alert-modal" */
  @Input() panelClass: string[] = ['error-alert-modal'];
  /** 是否顯示複製錯誤提示訊息到剪貼簿按鈕 */
  @Input() showCopyButton = false;
  /** 複製錯誤提示訊息到剪貼簿按鈕的標籤文字，預設為"Copy to clipboard"  */
  @Input() copyBtnLabel: string = 'Copy to clipboard';

  /** 複製錯誤提示訊息到剪貼簿 */
  copyTip(targetEl: HTMLElement) {
    window.getSelection()?.selectAllChildren(targetEl);
    document.execCommand('Copy');
  }
}
